import './StaffSettingsSection.css'

import { useState } from 'react'
import { useAtomValue, useSetAtom } from 'jotai'

import { staff } from '../../../store'

import { Button } from '../../../components/Button'
import { EmptyState } from '../../../components/EmptyState'
import { PageHeader } from '../../../components/PageHeader'
import { TextField } from '../../../components/TextField'

export function StaffSettingsAccountView() {
  const session = useAtomValue(staff.staffSessionAtom)
  const actionLoading = useAtomValue(staff.staffActionIsLoadingAtom)
  const actionError = useAtomValue(staff.staffActionErrorAtom)
  const changePassword = useSetAtom(staff.changeStaffPasswordAtom)

  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState<string | null>(null)

  if (!session) {
    return <EmptyState title="Not signed in" description="Staff session required." />
  }

  const handleSubmit = async () => {
    setMessage(null)
    if (!currentPassword || !newPassword) {
      setMessage('Both passwords are required.')
      return
    }
    if (newPassword !== confirmPassword) {
      setMessage('New passwords do not match.')
      return
    }
    const result = await changePassword({ currentPassword, newPassword })
    if (result.success) {
      setCurrentPassword('')
      setNewPassword('')
      setConfirmPassword('')
      setMessage('Password updated.')
    } else if (actionError === 'invalidCredentials') {
      setMessage('Current password is incorrect.')
    } else {
      setMessage('Could not update password.')
    }
  }

  return (
    <div className="staff-settings-section">
      <PageHeader
        title="Your account"
        subtitle={`Signed in as ${session.staff.email} (${session.staff.roleName || 'staff'}).`}
      />

      <section className="staff-settings-section__panel">
        <h2 className="staff-settings-section__heading">Change password</h2>
        <div className="staff-settings-section__form">
          <TextField
            label="Current password"
            kind="password"
            value={currentPassword}
            onChange={setCurrentPassword}
          />
          <TextField
            label="New password"
            kind="password"
            value={newPassword}
            onChange={setNewPassword}
          />
          <TextField
            label="Confirm new password"
            kind="password"
            value={confirmPassword}
            onChange={setConfirmPassword}
          />
          {message && <p className="staff-settings-section__error">{message}</p>}
          <Button
            kind="primary"
            text={actionLoading ? 'Saving…' : 'Update password'}
            disabled={actionLoading}
            onClick={handleSubmit}
          />
        </div>
      </section>
    </div>
  )
}
